import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Credentials } from "@app/core/shared/domain/credentials";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";

import { LoginMapper } from "@app/core/user/data/network/login.mapper";
import { LoginResponse } from "@app/core/user/domain/login.reponse";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";

/**
 * Web service used to log in.
 */
@Injectable({
  providedIn: "root",
})
export class LoginWS {
  constructor(private handler: BaseHandler) {}

  execute(credentials: Credentials): Observable<LoginResponse> {
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.LOGIN_ENDPOINT())
      .setMethod(HttpMethod.post)
      .setBody({
        email: credentials.email,
        password: credentials.password,
      })
      .build();

    return this.handler
      .execute(parameters)
      .pipe(map((response) => LoginMapper.deserialize(response)));
  }
}
